import { createReducer, on } from '@ngrx/store';
import { IUpgradePlanList } from '../../models/upgarde-plan.model';
import { loadUpgradePlanFailure, loadUpgradePlanInfo, loadUpgradePlanSuccess } from './upgrade-plan.action';

export interface UpgardePlanState {
    upgardePlanInfo: IUpgradePlanList | null;
    loading: boolean;
    error: string | null;
}

export const initialState: UpgardePlanState = {
    upgardePlanInfo: null,
    loading: false,
    error: null
};

export const ViewUpgardePlanInfoReducer = createReducer(
    initialState,
    on(loadUpgradePlanInfo, (state): UpgardePlanState => ({
        ...state,
        loading: true,
        error: null
    })),
    on(loadUpgradePlanSuccess, (state, { upgardePlanInfo }): UpgardePlanState => ({
        ...state,
        loading: false,
        upgardePlanInfo
    })),
    on(loadUpgradePlanFailure, (state, { error }): UpgardePlanState => ({
        ...state,
        loading: false,
        error
    }))
);
